import React, { useState, useEffect } from "react";
import { Typography, Grid, Chip } from "@mui/material";
import CustomTable from "components/TableExplanded/Table";
import CustomPagination from "components/TableExplanded/Pagination";
import useColumns from "pages/SuperAdmin/HistoryLog/columns/mainColumns";
import useColumnsTwo from "pages/SuperAdmin/HistoryLog/columns/subColumns";
import Modal from "components/Modal/Pawn/BuyProduct/ModalCreate";
import ViewModal from "components/Modal/Pawn/View/ViewBuyItems";
import SearchBar from "components/TableExplanded/SearchBar";
import api from "_api";
import useProductData from "./data/data";
import "assets/css/app.css";

const HistoryLog = ({ className }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectedProduct, setProduct] = useState(null);
  const [viewProduct, setViewProduct] = useState(null);
  const [fetchData, setFetchData] = useState();
  const [searchQuery, setSearchQuery] = useState(""); // Store the search query
  const [dataLength, setDataLength] = useState(0);

  const convertDateTH = (date) => {
    const utcDate = new Date(date);
    const thaiTime = new Date(utcDate.getTime() + 7 * 60 * 60 * 1000);
    return thaiTime
      .toLocaleString("th-TH", { timeZone: "Asia/Bangkok" })
      .split(" ");
  };

  const fetchHistoryLog = async () => {
    try {
      const { data, isStatus } = await api.super_admin.getHistoryLog();

      if (isStatus) {
        const updatedLogData =
          data.map((item) => ({
            id: item.id,
            username: item.User.username,
            table_name: item.table_name,
            type: (
              <Chip
                label={item.type == "create" ? "สร้าง" : "แก้ไข"}
                style={{
                  backgroundColor: `${
                    item.type == "create" ? "#2196F3" : "#EF6C00"
                  }`,
                  color: "white",
                }}
              ></Chip>
            ),
            created_at: (
              <div>
                <div>{convertDateTH(item.created_at)[0]}</div>
                <div>เวลา {convertDateTH(item.created_at)[1]}</div>
              </div>
            ),
          })) ?? [];

        console.log(updatedLogData);

        setFetchData(updatedLogData);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchHistoryLog();
  }, []);

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };

  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen,
    handleModalOpen
  );
  const columnsInside = useColumnsTwo();
  const visibleColumns = columns.filter((col) => col.showInFilter);

  const filteredData = React.useMemo(() => {
    if (!searchQuery) return data; // If no search query, return all data

    return data?.filter((row) => {
      return visibleColumns.some((column) => {
        const cellValue = row[column.accessor]?.toString()?.toLowerCase();
        return cellValue && cellValue.includes(searchQuery.toLowerCase());
      });
    });
  }, [data, searchQuery, visibleColumns]);

  console.log("filterdata", filteredData);

  const handleSearchChange = (event) => {
    // Check if event.target and event.target.value are defined
    if (
      event &&
      event.target &&
      event.target.value !== undefined &&
      event.target.value !== null
    ) {
      setSearchTerm(event.target.value.toLowerCase());
      setSearchQuery(event.target.value);
    } else {
      console.error("Event target or value is undefined");
    }
    setPage(0);
  };

  const handleClear = () => {
    setSearchTerm("");
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            History Log
          </Typography>
        </Grid>
      </Grid>

      <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        handleClear={handleClear}
        fetchData={fetchData}
        QRCode={true}
      />

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        searchTerm={searchTerm}
        data={filteredData}
        setDataLength={setDataLength}
        page={page}
        rowsPerPage={rowsPerPage}
      />
      <CustomPagination
        count={searchTerm ? dataLength : filteredData.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        fetchProductData={fetchHistoryLog}
        disableBackdropClick // Prevent clicking outside
        disableEscapeKeyDown // Prevent pressing `Esc`
      />

      <ViewModal
        open={isViewModalOpen}
        onClose={handleViewOpen}
        viewProduct={viewProduct}
      />
    </div>
  );
};

export default HistoryLog;
